import { render, staticRenderFns } from "./VideoConferences.vue?vue&type=template&id=7be09158"
import script from "./VideoConferences.vue?vue&type=script&lang=js"
export * from "./VideoConferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports